// PrivacyPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import './TermsPage.css';

const PrivacyPage = () => {
  return (
    <div className="simple-terms-page">
      {/* Header */}
      <div className="simple-header">
        <Link to="/" className="simple-logo">
          <span className="simple-logo-icon">🏠</span>
          <span>HomeManager</span>
        </Link>
        <Link to="/" className="simple-back-btn">← Back to Home</Link>
      </div>

      {/* Title */}
      <div className="simple-title-section">
        <h1>Privacy Policy</h1>
        <p>Last Updated: 21 January 2026</p>
        <p>This Privacy Policy explains how Home Manager ("we," "us," or "our") collects, uses, stores, and protects your personal information. By using our App, you consent to the practices described herein.</p>
      </div>

      {/* Content */}
      <div className="simple-content">
        <div className="simple-section">
          <h2>1. Information We Collect</h2>
          
          <h3>a) Personal Information</h3>
          <ul>
            <li>Full name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Gender</li>
            <li>Profile photo</li>
            <li>Personal ID (for verification of service professionals/agencies only)</li>
          </ul>
          
          <h3>b) Account Information</h3>
          <ul>
            <li>Encrypted login credentials</li>
            <li>Service preferences and history</li>
            <li>Transaction records</li>
            <li>Communications with other users</li>
          </ul>
          
          <h3>c) Technical Data</h3>
          <ul>
            <li>App activity logs</li>
            <li>Crash reports and performance data</li>
          </ul>
        </div>

        <div className="simple-section">
          <h2>2. How We Use Your Information</h2>
          <ul>
            <li><strong>Account creation and management</strong> - Contractual necessity</li>
            <li><strong>Identity verification</strong> - Legitimate interest</li>
            <li><strong>Service matching</strong> - Contractual necessity</li>
            <li><strong>Payment processing</strong> - Contractual necessity</li>
            <li><strong>Fraud prevention</strong> - Legitimate interest</li>
            <li><strong>Customer support</strong> - Contractual necessity</li>
          </ul>
        </div>

        <div className="simple-section">
          <h2>3. Permissions</h2>
          <p>Home Manager requests access to:</p>
          <ul>
            <li><strong>Camera:</strong> For capturing profile photos and verification documents</li>
            <li><strong>Gallery/Photos:</strong> For uploading existing images</li>
            <li><strong>Notifications:</strong> For service updates and alerts</li>
          </ul>
        </div>

        <div className="simple-section">
          <h2>4. Personal ID Processing</h2>
          <div className="highlight-box">
            <p><strong>Purpose:</strong> Identity verification and fraud prevention</p>
            <p><strong>Storage:</strong> Encrypted at rest, stored separately</p>
            <p><strong>Retention:</strong> 90 days after verification (or 7 years if disputed)</p>
            <p><strong>Security:</strong> Access restricted to authorized personnel only</p>
          </div>
        </div>

        <div className="simple-section">
          <h2>5. Payments & Financial Data</h2>
          <p>All payments are processed securely through Flutterwave. We do not store card numbers, bank details, or mobile money credentials.</p>
        </div>

        <div className="simple-section">
          <h2>6. Data Sharing</h2>
          <p>We do not sell your personal data. We share limited information with:</p>
          <ul>
            <li><strong>Flutterwave:</strong> Payment processing</li>
            <li><strong>Cloud Hosting Providers:</strong> Secure data storage</li>
            <li><strong>Legal Authorities:</strong> When required by law</li>
          </ul>
        </div>

        <div className="simple-section">
          <h2>7. Data Security</h2>
          <ul>
            <li>End-to-end encryption for data in transit</li>
            <li>Encryption at rest for sensitive data</li>
            <li>Regular security audits</li>
            <li>Access controls and authentication protocols</li>
          </ul>
        </div>

        <div className="simple-section">
          <h2>8. Data Retention</h2>
          <ul>
            <li><strong>Active accounts:</strong> Until account deletion</li>
            <li><strong>Inactive accounts:</strong> Deleted after 24 months</li>
            <li><strong>Transaction records:</strong> 7 years for compliance</li>
            <li><strong>Personal IDs:</strong> 90 days post-verification</li>
          </ul>
        </div>

        <div className="simple-section">
          <h2>9. Account & Data Deletion</h2>
          <p>You may delete your account:</p>
          <ul>
            <li><strong>Through App:</strong> Account → Delete Account</li>
            <li><strong>By Email:</strong> info@xigentechnologies.com</li>
          </ul>
        </div>

        <div className="simple-section">
          <h2>10. Your Rights</h2>
          <ul>
            <li>Access your personal data</li>
            <li>Edit inaccurate data</li>
            <li>Request deletion</li>
            <li>Data portability</li>
            <li>Withdraw consent</li>
          </ul>
        </div>

        <div className="simple-section contact-section">
          <h2>11. Contact Us</h2>
          <p><strong>Data Protection Contact:</strong> Xigen Technologies</p>
          <p><strong>Address:</strong> Plot 4, Colline House, Pilkington Road, Kampala, Uganda</p>
          <p><strong>Email:</strong> <a href="mailto:xigentechnologies@gmail.com">xigentechnologies@gmail.com</a></p>
          <p><strong>Website:</strong> <a href="https://www.xigentechnologies.com" target="_blank" rel="noopener noreferrer">www.xigentechnologies.com</a></p>
        </div>
      </div>

      {/* Footer */}
      <div className="simple-footer">
        <p>© 2026 Home Manager by Xigen Technologies. All rights reserved.</p>
        <div className="simple-footer-links">
          <Link to="/">Home</Link>
          <Link to="/terms">Terms & Conditions</Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;